import { render, staticRenderFns } from "./draggable-demo.vue?vue&type=template&id=5ee54b90&scoped=true"
import script from "./draggable-demo.vue?vue&type=script&lang=js"
export * from "./draggable-demo.vue?vue&type=script&lang=js"
import style0 from "./draggable-demo.vue?vue&type=style&index=0&id=5ee54b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee54b90",
  null
  
)

export default component.exports